module.exports = __webpack_public_path__ + "static/media/facebook.a49f4265.svg";